<template>
    <cms-modal unique="view-vessel-flag" title="View Flag History">
        <form @submit.prevent="confirmUpdateVesselFlag">

            <div class="form-group form-row mb-1" :class="{'has-error': vesselFlagErrors.vessel_name}">
                <label for="vessel-name" class="col col-sm-3 col-form-label font-weight-bolder">
                    Vessel Name:
                </label>
                <div class="col col-sm-8 offset-1 col-form-label p-0">
                    <input type="text" id="vessel-name" :readonly="!editable" required
                           class="form-control form-control-xs"
                           placeholder="Specify Vessel Name for this flag record"
                           v-model="vesselFlag.vessel_name"
                    >
                    <span class="help-block" v-if="vesselFlagErrors.vessel_name !== ''">
                      <small><strong>{{ vesselFlagErrors.vessel_name }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': vesselFlagErrors.date_from}">
                <label for="date-from" class="col col-sm-3 col-form-label font-weight-bolder">
                    Date From:
                </label>
                <div class="col col-sm-8 offset-1 col-form-label p-0">
                    <input type="date" id="date-from" v-if="editable"
                           class="form-control form-control-xs"
                           v-model="vesselFlag.date_from"
                    >
                    <input type="text" readonly v-else
                           class="form-control form-control-xs"
                           placeholder="Start Date Not Specified"
                           :value="vesselFlag.date_from | moment('D MMMM YYYY')"
                    >
                    <span class="help-block" v-if="vesselFlagErrors.date_from !== ''">
                      <small><strong>{{ vesselFlagErrors.date_from }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': vesselFlagErrors.date_to}">
                <label for="date-to" class="col col-sm-3 col-form-label font-weight-bolder">
                    Date To:
                </label>
                <div class="col col-sm-8 offset-1 col-form-label p-0">
                    <input type="date" id="date-to" v-if="editable"
                           class="form-control form-control-xs"
                           v-model="vesselFlag.date_to"
                    >
                    <input type="text" readonly v-else
                           class="form-control form-control-xs"
                           placeholder="End Date Not Specified"
                           :value="vesselFlag.date_to | moment('D MMMM YYYY')"
                    >
                    <span class="help-block" v-if="vesselFlagErrors.date_to !== ''">
                      <small><strong>{{ vesselFlagErrors.date_to }}</strong></small>
                    </span>
                </div>
            </div>

            <div class="form-group form-row mb-1" :class="{'has-error': vesselFlagErrors.country_id}">
                <label for="country" class="col col-sm-3 col-form-label font-weight-bolder">
                    Flag:
                </label>
                <div class="col col-sm-8 offset-1 col-form-label p-0">
                    <select id="country" class="form-control form-control-xs"
                            :disabled="!editable"
                            v-model="vesselFlag.country_id"
                    >
                        <option :value="null">--- Select Flag ---</option>
                        <option v-for="countryKey in countryKeys" :key="countryKey.id"
                                :value="countryKey.id"
                        >
                            {{ countryKey.name }}
                        </option>
                    </select>
                    <span class="help-block" v-if="vesselFlagErrors.country_id !== ''">
                      <small><strong>{{ vesselFlagErrors.country_id }}</strong></small>
                    </span>
                </div>
            </div>

            <hr />
            <div class="float-right">
                <button type="submit" class="btn btn-warning btn-sm btn-xs mr-3 font-weight-bolder"
                        v-if="isSystemAdmin || isPrincipal || isPrincipalStaff || isDesignatedPrincipal">
                    <i class="fas fa-edit"></i>
                    {{ editable ? 'Update' : 'Edit' }}
                </button>
                <button class="btn btn-danger btn-sm btn-xs font-weight-bolder"
                        v-if="editable"
                        @click="cancelEdit"
                >
                    <span class="fas fa-ban"></span>
                </button>
            </div>

        </form>
    </cms-modal>
</template>

<script>
/* eslint-disable */
import { vueAppMixin } from "@/mixins/vueAppMixin";
import { formMixin } from "@/mixins/formMixin";
import { gateMixin } from "@/mixins/gateMixin";
import { mapActions, mapGetters} from "vuex";

import CmsModal from "@/components/elements/CmsModal";

export default {
    name: "EditFlagHistory",

    mixins: [ vueAppMixin, formMixin, gateMixin ],

    components: { CmsModal },

    props: {
        viewVesselFlag: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    data() {
        return {
            vesselFlag: {},
            vesselFlagErrors: {},
            editable: false,
            editableFields: [
                'id', 'vessel_name', 'date_from', 'date_to', 'country_id'
            ]
        }
    },

    methods: {
        ...mapActions([
            'updateVesselFlag'
        ]),

        async confirmUpdateVesselFlag() {
            if(this.editable) {
                if(await this.confirmUpdate()) {
                    let params = {};
                    this.editableFields.forEach(key => {
                        let value = this.vesselFlag[key] ? this.vesselFlag[key] : '';
                        if(value === '0000-00-00') value = '';
                        // formData.append(key, value);
                        params[key] = value;
                    });
                    let updatedVesselFlag = await this.updateVesselFlag(params);
                    if(updatedVesselFlag) {
                        if(updatedVesselFlag.errors) {
                            this.vesselFlagErrors = updatedVesselFlag.errors;
                        } else {
                            this.successAlert('Vessel Flag History Record Successfully Updated', 'UPDATE');
                            document.getElementById('close-view-vessel-flag').click();
                            this.vesselFlag = Object.assign({}, updatedVesselFlag);
                            this.vesselFlagErrors = {};
                        }
                    }
                }
            } else {
                this.editable = true;
            }
        },

        cancelEdit() {
            this.editable = false;
            this.vesselFlag = Object.assign({}, this.viewVesselFlag);
        }

    },

    computed: {
        ...mapGetters([
            'countryKeys'
        ])
    },

    created() {

    },

    watch: {
        'viewVesselFlag'() {
            this.vesselFlag = Object.assign({}, this.viewVesselFlag);
            this.editable = false;
        }
    }

}
</script>

<style scoped>

</style>